import React from 'react';

interface CopyrightProps {
  companyName: string;
  className?: string;
}

export const Copyright: React.FC<CopyrightProps> = ({
  companyName,
  className = '',
}) => {
  return (
    <p className={`text-dark-500 text-sm ${className}`}>
      &copy; {new Date().getFullYear()} {companyName}, Inc. All rights reserved.
    </p>
  );
};
